import { useState, useEffect } from 'react';
import {
  Button,
  FlexContainer,
  LogoApps,
  useDeviceSize,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useAuth, useData } from '../../providers';
import { RoutesName } from '../../states';
import { recordOnboardingState } from '../../states/atoms';
import { ModalLogout } from '../logout';
import { LanguageSelection } from './LanguageSelection';
import { FlexContainerLink, HeaderStyles } from './Styles';

export const Header = () => {
  const { logout, logged, terms, initError } = useAuth();
  const { disconnect, resetStates, clearPolling } = useData();
  const { t } = useTranslation();

  const { isMobile } = useDeviceSize();
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);
  const showConfigBtn = location.pathname === RoutesName.home;
  const recordOnboarding = useRecoilValue(recordOnboardingState);

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const InnerLogo = () => (
    <LogoApps
      logoApp="Onboarding"
      size="40"
      labelLines={isMobile ? '2' : '1'}
      color="white"
    />
  );

  const onClickLogo = () => {
    disconnect();
    resetStates();
    clearPolling();
    if (!recordOnboarding) {
      navigate(RoutesName.home);
    } else {
      window.location.href = '/';
    }
  };

  const handleConfigClick = () => {
    location.pathname !== RoutesName.terms &&
      navigate(RoutesName.configuration);
  };

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (initError) {
      navigate(RoutesName.noAuthorized);
      timeoutId = setTimeout(() => logout(), 3000);
    }
    return () => timeoutId && clearTimeout(timeoutId);
  }, [initError]);

  return (
    <>
      {logged && terms ? (
        <HeaderStyles
          forwardedAs="header"
          alignItems="center"
          justifyContent="space-between"
        >
          <>
            <FlexContainerLink
              alignItems="center"
              columnGap="1.6"
              onClick={onClickLogo}
            >
              <InnerLogo />
            </FlexContainerLink>

            <FlexContainer
              alignItems="center"
              columnGap={!isMobile ? '1.6' : 'unset'}
            >
              {showConfigBtn && (
                <Button
                  color="white"
                  iconName="Gear"
                  variant="text"
                  testId="main_view_settings_button"
                  onClick={handleConfigClick}
                >
                  {!isMobile && t('Configuration')}
                </Button>
              )}
              <Button
                color="white"
                variant="text"
                onClick={handleLogout}
                testId="main_view_logout_button"
                iconName="SignOut"
              >
                {!isMobile && t('Exit')}
              </Button>
              <ModalLogout
                show={showLogoutModal}
                onChangeShow={(showModal) => setShowLogoutModal(showModal)}
                onLogout={logout}
              />
            </FlexContainer>
          </>
        </HeaderStyles>
      ) : (
        <LanguageSelection />
      )}
    </>
  );
};
